export default __webpack_public_path__ + "static/vector-shape6-571a738d8be912721121ee3a3d3a05a3.png";